(() => {
  const ARENA_PATHS = [
    ['118','M1.5,362.3h307.4v607.2h-307.4z',150,733,139],['101','M1.5,2243.1h294.6v606h-294.6z',149,2661,139],
    ['102','M306.2,2849.1v-606h428.1v218.5l54.8,88.3v299.2z',522,2661,139],
    ['103','M799.1,2754.7v-207.7l-54.8,-88.4v-215.6h407.9v179.5l-41.8,81.2v251z',948,2636,139],
    ['104','M1120.4,2754.7v-248.6l41.8,-81.1v-182h405.3v180.3l-15.1,81.1v250.3z',1341,2631,139],
    ['105','M1562.4,2754.7v-249.4l15.1,-81.1v-181.2h432.9v180.1l-83.6,331.6z',1783,2631,139],
    ['106','M1935.7,2849.1v-88.7l84.7,-335.9v-181.4h370.1v190l42.3,80.9l55.8,246.4v88.7z',2200,2631,135],
    ['107','M2497.6,2754.7l-55.3,-244.3l-41.8,-79.8v-188.7l71.2,-17.7l57.6,-31.8h45.7l105,24.4h55l314.1,70.5l-106.7,234.6l-199.9,175.4l-170.1,57.4z',2695,2548,135],
    ['108','M3057.5,2278.9l-321.4,-72.1h-55l-105,-24.4h-43.1v-258.1h617.1v266.8l-16,112.1z',2820,2128,135],
    ['109','M2533,1622.7h520.2v291.6h-520.2z',2793,1788,139],['110','M2533,1612.7v-291.8h520.2v291.8z',2793,1487,139],
    ['111','M3063.2,1400.5v-89.6h-530.2v-258.3h50.9l-1,-1.9l88.7,-21h57.1l411.6,-77.1l9.8,85.8v362.1z',2820,1230,135],
    ['112','M2493.6,988.9l-80.5,-18.3v-48.2c-0.1,0 -0.1,-128.9 -0.1,-128.9l38.8,-68.7l88.7,-264.8l188.5,58.3l216.1,202.9l97.6,193.3l8.8,44.7l-323.8,60.6h-57.3l-95.6,22.6l-44.2,0.3z',2680,800,135],
    ['113','M2056.3,969.5v-182.7l-42.2,-79.9l-60,-248.6h576.4l-87.9,262.4l-39.6,70.1v136.5h0.2v42.2z',2210,775,135],
    ['114','M1590.3,969.5v-181.9l-15.1,-79.4v-249.9h368.6l60.8,252.2l41.7,78.8v180.2z',1792,775,139],
    ['115','M1176.3,969.5v-182.7l-43.1,-79.4v-249.1h432v250.9l15.1,79.3v181z',1350,775,139],
    ['116','M758.2,969.5v-208.8l63.7,-86.6v-215.8h301.3v251.7l43.1,79.3v180.2z',957,780,135],
    ['117','M318.9,969.5v-607.2h493v308.5l-63.7,86.6v212.1z',528,735,139],
    ['401','M1.5,2859.1h304.2v354h-304.2z',154,3105,139],['402','M315.8,2859.1h429v354h-429z',530,3107,139],
    ['403','M754.8,2859.1h597.1v354h-597.1z',1053,3108,139],['404','M1361.9,2859.1h382.2v354h-382.2z',1553,3107,139],
    ['405','M1754,2859.1h442.7v354h-442.7z',1975,3107,139],
    ['406','M2206.7,3213.1v-354h338.9v63.9l13.6,29v261.1z',2380,3107,135],
    ['407','M2569.2,3213.1v-263.3l-13.6,-29.1v-61.6h327.8v74.4l157.2,20.6l187,147l-92.3,112z',2790,3110,130],
    ['408','M3044.6,2944.5l-151.2,-19.9v-69.1l216.8,-320.7l31.1,-18.3h27.4l26.3,43.2l288,144.3l-249.9,388.6z',3170,2790,120],
    ['409','M3202,2552.2l-27.7,-45.6h-35.7l-25.5,14.9l46.4,-325h62.9l17.8,20.4h286.8v109.3l-39.8,368.8l-285.2,-142.8z',3330,2410,120],
    ['410','M3244.8,2206.9l-17.9,-20.4h-66.8v-372h55.5l29,23.7h282.4v368.7z',3360,2050,125],
    ['411','M3248.2,1828.2l-29,-23.7h-59.1v-393.9h55.6l29.1,21.3h282.2v396.3z',3355,1660,125],
    ['412','M3248,1421.9l-29,-21.3h-58.9v-363h77.6l10.9,29.6h278.4v354.7z',3360,1265,125],
    ['413','M3255.6,1057.1l-11,-29.6h-85.7l-9.4,-81.6l-19.9,-96.6l-46.6,-112.5l243.8,-133.1l132.1,-40l68.1,344.6v148.8z',3340,910,120],
    ['414','M3051.7,661l-190,-170.9l39,-195.5h161.1l187.2,-105.6l174.4,285.3l32.8,76.2l0.7,3.5l-134,40.5l-243.7,133.1z',3160,470,120],
    ['415','M2771.6,409.1l-233.6,-55.5h-21.5v-60.6l54,-21.8v-269.6h564l109.3,178.9l-184.6,104.1h-166.7l-39.5,197.8z',2820,210,120],
    ['416','M2194.1,353.5v-352h366.4v262.9l-54,21.8v67.3z',2360,200,135],
    ['417','M1732.3,1.5h451.9v352h-451.9z',1958,200,139],
    ['418','M1570.2,353.5l-324,-2.3v-349.7h476.1v352z',1485,200,135],
    ['419','M758.2,352.3v-350.8h478v349.6h-108l-311.3,1.2z',997,200,135],
    ['420','M318.9,1.5h429.4v350.8h-429.4z',534,200,139],['421','M1.5,1.5h307.4v350.8h-307.4z',155,200,139],
    ['203','M799.1,2764.7h311.4v84.3h-311.4z',955,2825,52],['204','M1120.4,2764.7h431.9v84.3h-431.9z',1336,2825,52],
    ['205','M1562.4,2764.7h363.3v84.3h-363.3z',1744,2825,52],
    ['207','M2498.6,2849.1v-84.3h75.4l173.6,-58.5l203,-178.2l108.3,-238.1l73.8,23.3l-6.1,42.6l-88.3,212.9l-234.3,232.8l-168.3,47.5z',2640,2790,46],
    ['209','M3053.2,1622.7h96.9v291.6h-96.9z',3101,1790,44],['210','M3053.2,1410.5h96.9v202.2h-96.9z',3101,1530,44],
    ['212','M3052.3,911.1l-99,-196.1l-219.1,-205.7l-191.8,-59.3v-85.2l224.4,53.4l276.5,248.7l76.7,185.3l18.7,90.5l-77.4,14.5z',2790,560,44],
    ['213','M1872.4,363.5h660v84.9h-660z',2202,422,52],['214','M1575.2,363.5h287.2v84.9h-287.2z',1719,422,50],
    ['215','M1133.2,448.3v-87.2h108l324,2.3v84.9z',1349,422,50],['216','M821.9,448.3v-86l301.3,-1.2v87.2z',962,422,50],
    ['A','M635.5,1438.3h312.2v172.6h-312.2z',791,1545,72],['B','M635.5,1206.7h521v155.3h-521z',895,1305,72],
    ['C','M635.5,990.5h521v170.3h-521z',895,1097,72],['L','M635.5,1862.2h521v155.2h-521z',895,1960,72],
    ['M','M635.5,2078.9h521v129.4h-521z',895,2165,68],['N','M1000.4,1628h312.2v172.6h-312.2z',1156,1735,72],
    ['G','M1762.1,1206.7h199.4v155.3h-199.4z',1861,1305,68],['F','M1194.6,990.5h511.4v170.3h-511.4z',1450,1097,72],
    ['D','M1000.4,1438.3h312.2v172.6h-312.2z',1156,1545,72],['O','M1194.6,1862.2h511.4v155.2h-511.4z',1450,1960,72],
    ['R','M1771.1,1862.2h195.4v155.2h-195.4z',1868,1960,68],['K','M635.5,1628h312.2v172.6h-312.2z',791,1735,72],
    ['E','M1194.6,1206.7h511.4v155.3h-511.4z',1450,1305,72],['P','M1194.6,2078.9h511.4v129.4h-511.4z',1450,2165,68],
    ['H','M1791.8,990.5h169.8v170.3h-169.8z',1876,1097,68],['I','M2077.6,1071.3h152.7v415.3h-152.7z',2153,1300,72],
    ['S','M1808.1,2078.9h152.3v129.4h-152.3z',1884,2165,64],['T','M2077.6,1754.4h152.7v415.3h-152.7z',2153,1983,72],
    ['W','M1392.5,1628h399.3v172.6h-399.3z',1591,1735,72],['Z','M1392.5,1438.3h399.3v172.6h-399.3z',1591,1545,72]
  ];
  const AVAILABLE_DEMO = new Set(['A','K','B','L','C','M','118','101','117','102','116','103','104','107','112']);
  const SVG_NS = 'http://www.w3.org/2000/svg';

  const money = (cents, currency = 'EUR') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
    } catch (_) {
      return `€${(cents / 100).toFixed(2)}`;
    }
  };

  const svgEl = (name, attrs = {}) => {
    const node = document.createElementNS(SVG_NS, name);
    Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, String(value)));
    return node;
  };

  function renderArenaMap(container, availableSections, selectedSection = null, interactive = true) {
    if (!container) return;
    container.innerHTML = '';
    const svg = svgEl('svg', { viewBox: '-363 -331 4254 3876', role: 'img', 'aria-label': 'Plan des sections de la salle' });
    if (container.matches('[data-st-demo-map]')) svg.classList.add('st-demo-map-svg');

    const stage = svgEl('path', { d: 'M52.4,1130.7h392.3v986h-392.3z', class: 'st-map-stage' });
    svg.appendChild(stage);

    ARENA_PATHS.forEach((p) => {
      const [id, d, tx, ty, fs] = p;
      const available = availableSections.has(String(id));
      const selected = selectedSection === String(id);
      const path = svgEl('path', {
        d,
        'data-section-id': id,
        class: `st-map-section${available ? ' is-available' : ''}${selected ? ' is-selected' : ''}`,
        tabindex: available && interactive ? '0' : '-1',
        role: available && interactive ? 'button' : 'img',
        'aria-label': available ? `Section ${id}, disponible à 179,90 €` : `Section ${id}, complète`
      });
      if (available && interactive) {
        path.addEventListener('click', () => selectSection(container.closest('[data-st-ticket]'), String(id)));
        path.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectSection(container.closest('[data-st-ticket]'), String(id)); } });
      }
      svg.appendChild(path);

      const label = svgEl('text', { x: tx, y: ty, 'font-size': Math.max(Number(fs || 70), 52), class: `st-map-label${available ? ' is-available' : ''}${selected ? ' is-selected' : ''}` });
      label.textContent = id;
      svg.appendChild(label);
    });

    container.appendChild(svg);
  }

  function availableSectionsFromRoot(root) {
    return new Set(Array.from(root?.querySelectorAll('[data-st-seat-option]') || []).filter((el) => !el.classList.contains('is-unavailable') && !el.disabled).map((el) => el.dataset.section).filter(Boolean));
  }

  function syncMapSelection(root, section) {
    const map = root?.querySelector('[data-st-seatmap]');
    if (!map) return;
    renderArenaMap(map, availableSectionsFromRoot(root), section, true);
  }

  function updateView(root, option, section) {
    const image = root?.querySelector('[data-st-view-image]');
    const title = root?.querySelector('[data-st-view-title]');
    const url = option?.dataset.viewUrl;
    if (title) title.textContent = `Section ${section}`;
    if (image && url && image.getAttribute('src') !== url) {
      image.style.opacity = '0';
      window.setTimeout(() => {
        image.src = url;
        image.alt = `Vue de référence depuis la section ${section}`;
        image.onload = () => { image.style.opacity = '1'; image.style.transform = 'scale(1.015)'; window.setTimeout(() => image.style.transform = '', 280); };
      }, 120);
    }
  }

  function updateSeatCount(root, section) {
    const visible = Array.from(root?.querySelectorAll('[data-st-seat-option]') || []).filter((el) => el.dataset.section === section && !el.classList.contains('is-unavailable') && !el.disabled);
    const count = root?.querySelector('[data-st-seat-count]');
    if (count) count.textContent = `${visible.length} billet${visible.length > 1 ? 's' : ''} disponible${visible.length > 1 ? 's' : ''} · Section ${section}`;
  }

  function selectSection(root, section) {
    if (!root || !section) return;
    const options = Array.from(root.querySelectorAll('[data-st-seat-option]'));
    options.forEach((opt) => opt.classList.toggle('is-hidden', opt.dataset.section !== section));
    updateSeatCount(root, section);
    const selectedInSection = options.find((opt) => opt.dataset.section === section && opt.classList.contains('is-selected'));
    const first = selectedInSection || options.find((opt) => opt.dataset.section === section && !opt.classList.contains('is-unavailable') && !opt.disabled);
    if (first) updateSelection(root, first, false);
    syncMapSelection(root, section);
    updateView(root, first, section);
  }

  function updateSelection(root, option, syncSection = true) {
    if (!root || !option || option.disabled || option.classList.contains('is-unavailable')) return;
    root.querySelectorAll('[data-st-seat-option]').forEach((el) => el.classList.toggle('is-selected', el === option));
    const variantId = option.dataset.variantId;
    const price = Number(option.dataset.priceCents || 0);
    const label = option.dataset.label || 'Billet sélectionné';
    const description = option.dataset.description || 'Billet numéroté.';
    const section = option.dataset.section;
    const idInput = root.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = variantId;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const name = root.querySelector('[data-st-selection-name]');
    const priceEl = root.querySelector('[data-st-selection-price]');
    const desc = root.querySelector('[data-st-selection-desc]');
    const total = root.querySelector('[data-st-total]');
    if (name) name.textContent = label;
    if (priceEl) priceEl.textContent = money(price, root.dataset.currency || 'EUR');
    if (desc) desc.textContent = description;
    if (total) total.textContent = money(price, root.dataset.currency || 'EUR');
    root.dataset.unitPrice = String(price);
    if (syncSection && section) {
      root.querySelectorAll('[data-st-seat-option]').forEach((opt) => opt.classList.toggle('is-hidden', opt.dataset.section !== section));
      updateSeatCount(root, section);
      syncMapSelection(root, section);
    }
    if (section) updateView(root, option, section);
  }

  function initTicket(root) {
    const options = Array.from(root.querySelectorAll('[data-st-seat-option]')).filter((el) => !el.classList.contains('is-unavailable') && !el.disabled);
    if (!options.length) return;
    const selected = options.find((el) => el.classList.contains('is-selected')) || options[0];
    const section = selected.dataset.section || root.dataset.initialSection || options[0].dataset.section;
    renderArenaMap(root.querySelector('[data-st-seatmap]'), availableSectionsFromRoot(root), section, true);
    selectSection(root, section);
    updateSelection(root, selected, true);
  }

  function initDemoMaps() {
    document.querySelectorAll('[data-st-demo-map]').forEach((map) => renderArenaMap(map, AVAILABLE_DEMO, null, false));
  }

  function initAccordions() {
    document.querySelectorAll('[data-st-accordion]').forEach((accordion) => {
      accordion.querySelectorAll('.st-accordion__item > button').forEach((button) => {
        button.addEventListener('click', () => {
          const item = button.closest('.st-accordion__item');
          const open = item.classList.contains('is-open');
          accordion.querySelectorAll('.st-accordion__item').forEach((other) => {
            other.classList.remove('is-open');
            other.querySelector(':scope > button')?.setAttribute('aria-expanded', 'false');
          });
          if (!open) { item.classList.add('is-open'); button.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  }

  function initMenu() {
    const toggle = document.querySelector('[data-st-menu-toggle]');
    const menu = document.querySelector('[data-st-mobile-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', () => {
      const next = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(next));
      menu.classList.toggle('is-open', next);
    });
    menu.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => { toggle.setAttribute('aria-expanded','false'); menu.classList.remove('is-open'); }));
  }

  document.addEventListener('click', (event) => {
    const yearTab = event.target.closest('[data-st-year]');
    if (yearTab) {
      const year = yearTab.dataset.stYear;
      document.querySelectorAll('[data-st-year]').forEach((el) => el.classList.toggle('is-active', el === yearTab));
      document.querySelectorAll('[data-st-event-year]').forEach((row) => row.classList.toggle('is-hidden', year !== 'all' && row.dataset.stEventYear !== year));
      return;
    }
    const option = event.target.closest('[data-st-seat-option]');
    if (option) updateSelection(option.closest('[data-st-ticket]'), option, true);
  });



  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' }[char]));

  function updateHeaderCartCount(count) {
    const node = document.querySelector('[data-st-cart-count]');
    if (!node) return;
    const qty = Number(count || 0);
    node.textContent = qty > 99 ? '99+' : String(qty);
    node.classList.toggle('is-empty', qty === 0);
  }

  function cartDrawer() { return document.querySelector('[data-st-cart-drawer]'); }

  function openCartDrawer() {
    const drawer = cartDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('st-cart-drawer-open');
    window.setTimeout(() => drawer.querySelector('[data-st-cart-close]')?.focus({ preventScroll: true }), 180);
  }

  function closeCartDrawer() {
    const drawer = cartDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('st-cart-drawer-open');
  }

  function renderCartDrawer(cart) {
    const drawer = cartDrawer();
    if (!drawer || !cart) return;
    const body = drawer.querySelector('[data-st-cart-body]');
    const footer = drawer.querySelector('[data-st-cart-footer]');
    const count = drawer.querySelector('[data-st-drawer-count]');
    const total = drawer.querySelector('[data-st-cart-total]');
    updateHeaderCartCount(cart.item_count);
    if (count) count.textContent = cart.item_count ? String(cart.item_count) : '';
    if (total) total.textContent = money(cart.total_price, cart.currency || 'EUR');

    if (!cart.items?.length) {
      if (body) body.innerHTML = `<div class="st-cart-empty"><span>◇</span><h3>Votre panier est vide</h3><p>Choisissez une date puis un siège disponible.</p><a href="${escapeHtml(window.ShipoTicketRoutes?.tickets || '/collections/all')}">Voir les billets</a></div>`;
      footer?.classList.add('is-empty');
      return;
    }

    footer?.classList.remove('is-empty');
    if (body) {
      body.innerHTML = `<div class="st-cart-lines">${cart.items.map((item) => {
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        const section = variant.split(' · ')[0] || 'Billet';
        return `<article class="st-cart-line" data-key="${escapeHtml(item.key)}">
          <div class="st-cart-line__icon">${escapeHtml(section)}</div>
          <div class="st-cart-line__content">
            <a href="${escapeHtml(item.url || '#')}">${escapeHtml(item.product_title)}</a>
            <p>${escapeHtml(variant)}</p>
            <div class="st-cart-line__meta"><span>${money(item.final_line_price, cart.currency || 'EUR')}</span><small>Quantité : ${item.quantity}</small></div>
            <button type="button" data-st-cart-remove data-key="${escapeHtml(item.key)}">Supprimer</button>
          </div>
        </article>`;
      }).join('')}</div>`;
    }
  }

  async function fetchCart() {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!response.ok) throw new Error('Impossible de charger le panier.');
    return response.json();
  }

  async function syncCartDrawer(openAfter = false) {
    const cart = await fetchCart();
    renderCartDrawer(cart);
    if (openAfter) openCartDrawer();
    return cart;
  }

  function setTicketButtonState(form, state, message = '') {
    const button = form?.querySelector('.st-ticket-atc');
    const label = button?.querySelector('[data-st-atc-label]');
    const status = form?.querySelector('[data-st-atc-message]');
    if (!button) return;
    button.classList.remove('is-loading', 'is-success', 'is-error');
    button.removeAttribute('aria-busy');
    if (state === 'loading') {
      button.disabled = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'Ajout en cours…';
    } else if (state === 'success') {
      button.disabled = false;
      button.classList.add('is-success');
      if (label) label.textContent = '✓ Ajouté au panier';
    } else if (state === 'error') {
      button.disabled = false;
      button.classList.add('is-error');
      if (label) label.textContent = 'Réessayer';
    } else {
      button.disabled = false;
      if (label) label.textContent = 'Ajouter ce billet au panier';
    }
    if (status) {
      status.textContent = message;
      status.classList.toggle('is-visible', Boolean(message));
      status.classList.toggle('is-error', state === 'error');
      status.classList.toggle('is-success', state === 'success');
    }
  }

  function markTicketUnavailable(root, variantId) {
    const option = root?.querySelector(`[data-st-seat-option][data-variant-id="${CSS.escape(String(variantId))}"]`);
    if (!option) return;
    option.classList.add('is-unavailable');
    option.disabled = true;
    option.setAttribute('aria-disabled', 'true');
    option.querySelector('.st-seat-option__price')?.replaceChildren(document.createTextNode('Indisponible'));
    const section = option.dataset.section;
    const alternatives = Array.from(root.querySelectorAll('[data-st-seat-option]')).filter((el) => el.dataset.section === section && !el.disabled && !el.classList.contains('is-unavailable'));
    if (alternatives.length) updateSelection(root, alternatives[0], true);
    else {
      const next = Array.from(root.querySelectorAll('[data-st-seat-option]')).find((el) => !el.disabled && !el.classList.contains('is-unavailable'));
      if (next) selectSection(root, next.dataset.section);
      else syncMapSelection(root, null);
    }
  }

  async function handleTicketAdd(form) {
    const variantInput = form.querySelector('input[name="id"]');
    const variantId = Number(variantInput?.value || 0);
    const rootEl = form.closest('[data-st-ticket]');
    if (!variantId) {
      setTicketButtonState(form, 'error', 'Veuillez sélectionner un billet disponible.');
      return;
    }

    setTicketButtonState(form, 'loading');
    try {
      const rootPath = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw Object.assign(new Error(data.description || data.message || 'Ce billet ne peut pas être ajouté.'), { status: response.status });

      const cart = await fetchCart();
      renderCartDrawer(cart);
      setTicketButtonState(form, 'success', 'Billet ajouté à votre panier.');
      openCartDrawer();
      window.setTimeout(() => setTicketButtonState(form, 'idle', ''), 1700);
    } catch (error) {
      if (error?.status === 422) {
        markTicketUnavailable(rootEl, variantId);
        setTicketButtonState(form, 'error', 'Ce billet est déjà dans votre panier ou n’est plus disponible. Choisissez un autre siège.');
      } else {
        setTicketButtonState(form, 'error', error?.message || 'Impossible d’ajouter ce billet. Veuillez réessayer.');
      }
    }
  }

  async function removeCartLine(key) {
    const rootPath = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${rootPath}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    const cart = await response.json();
    if (!response.ok || cart.status) throw new Error(cart.description || 'Impossible de modifier le panier.');
    updateHeaderCartCount(cart.item_count);
    if (document.body.classList.contains('template-cart')) {
      window.location.reload();
      return;
    }
    renderCartDrawer(cart);
  }

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form?.matches('[data-st-ticket-form]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    handleTicketAdd(form);
  }, true);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-st-cart-trigger]');
    if (trigger) {
      event.preventDefault();
      syncCartDrawer(true).catch(() => openCartDrawer());
      return;
    }
    if (event.target.closest?.('[data-st-cart-close]')) {
      event.preventDefault();
      closeCartDrawer();
      return;
    }
    const remove = event.target.closest?.('[data-st-cart-remove]');
    if (remove) {
      event.preventDefault();
      remove.disabled = true;
      removeCartLine(remove.dataset.key).catch(() => { remove.disabled = false; });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && cartDrawer()?.classList.contains('is-open')) closeCartDrawer();
  });

  document.addEventListener('DOMContentLoaded', () => {
    initMenu();
    initAccordions();
    initDemoMaps();
    document.querySelectorAll('[data-st-ticket]').forEach(initTicket);
    fetchCart().then((cart) => updateHeaderCartCount(cart.item_count)).catch(() => {});
  });
})();
